<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Name:</label>
        <div>
          <input type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >Add Project Phase</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import * as database from "@/vendor/database";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  components: {
    spinnerButton,
  },
  data() {
    return {
      submitLoading: false,
      editName: null,
    };
  },
  created: function () {
    this.initData();
  },
  methods: {
    initData: function () {
      this.editName = null;
      this.submitLoading = false;
    },
    buttonClick: function () {
      this.submitLoading = true;
      database
        .addDoc("project_phases", { name: this.editName })
        .then((result) => {
          if (result.ok) {
            this.$toasted.global.toast_success({
              message: "add success",
            });
            this.$emit("closePanel");
          } else {
            this.$toasted.global.toast_error({ message: "add error" });
          }
        })
        .catch((error) => {
          this.$toasted.global.toast_error({ message: error });
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>
